module.exports = __webpack_public_path__ + "static/img/news_program_5.0672747b.jpeg";